import { withTranslation } from "i18n";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Alert, Button, Modal, Spinner } from "react-bootstrap";
import { TiTick } from "react-icons/ti";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { getOnlineExamStartAsync, resetPlanOffset } from "redux/onlineExam/onlineExam.actions";
import { selectErrorFetchingExams, selectErrorFetchingPostExam, selectExamOnlineLoadMore, selectExamOnlineOffset, selectIsFetchingExams, selectOnlineExamData, selectOnlineExamDetailData } from "redux/onlineExam/onlineExam.selectors";
import { commonStrigns, stringFiles } from "res/strings";
import { createStructuredSelector } from "reselect";
import { Box } from "styled-components/box";
import { SkeletonLine } from "styled-components/skeleton/SkeletonLine";
import { CookieUtils } from "utils";
import PlanCard from "../../components/assessment/PlanCard";



const Plan = ({ t, checkUnfinishedExams }) => {
  const [show, setShow] = useState(false);

  const hintVideoUrl = "http://cdn3.dayamooz.com/Files/GuideVideos/OnlineExam/AppParent_UploadImages.mp4";

  const dispatch = useDispatch();
  const router = useRouter();
  const cookieInstance = new CookieUtils();
  const studentID = cookieInstance.getCookie("studentID");
  const semesterID = cookieInstance.getCookie("semesterID");

  const {
    onlineExamData,
    isFetchingExams,
    errorFetchingExams,
    offset,
    loadMore,
    currentUser,
    onlineExamDetailData,
    errorFetchingPostExam
  } = useSelector(
    createStructuredSelector({
      onlineExamDetailData: selectOnlineExamDetailData,
      errorFetchingPostExam: selectErrorFetchingPostExam,

      //
      onlineExamData: selectOnlineExamData,
      isFetchingExams: selectIsFetchingExams,
      errorFetchingExams: selectErrorFetchingExams,
      offset: selectExamOnlineOffset,
      loadMore: selectExamOnlineLoadMore,
    })
  );

  useEffect(() => {
    dispatch(resetPlanOffset());
    getExamList()
  }, []);





  const getExamList = () => {
    dispatch(getOnlineExamStartAsync({ studentID: studentID, semesterID: semesterID }))
  }


  return (
    <Box className="w-100 d-flex flex-column p-2">

      {isFetchingExams && !loadMore ? (
        //Loading
        <>
          {[1, 2, 3, 4, 5, 6].map((item, idx) => (
            <Box key={idx} width="100%" height="50px" className="my-1">
              <SkeletonLine />
            </Box>
          ))}
        </>
      ) : onlineExamData && !errorFetchingExams ? (
        //Show Data
        <>
          <Alert show={onlineExamData.length > 0} variant="warning" className="p-2 m-1 shadow border">
            <p className="text-left">
              {t("onlineExam.hintAlert")}
        </p>
            <div className="d-flex justify-content-end">
              <Button onClick={() => setShow(true)} variant="outline-success">
                {t("onlineExam.seeHints")}
          </Button>
            </div>
          </Alert>

          <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
              <Modal.Title className="text-warning app-text-sm ">
                {t("onlineExam.examHintHeader")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-left">
              <p className="text-primary">
                {t("onlineExam.examHintLabel")}
              </p>
              <ul>
                <li>
                  {t("onlineExam.firstHint")}
                </li>
                <li>
                  {t("onlineExam.secondHint")}
                </li>

              </ul>

              <HintComponent title={t("onlineExam.thirdHint")} />
              <HintComponent title={t("onlineExam.fourthHint")} />
              <HintComponent title={t("onlineExam.fifthHint")} />
              <HintComponent title={t("onlineExam.sixthHint")} />

              <a href={hintVideoUrl} target="_blank">
                {t("onlineExam.watchHintMovie")}
              </a>


            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShow(false)}>
                باشه
          </Button>

            </Modal.Footer>
          </Modal>
          <InfiniteScroll
            dataLength={onlineExamData.length} //This is important field to render the next data
            next={() => getExamList()}
            hasMore={loadMore}
            loader={<Spinner className='d-flex mx-auto align-self-center' animation="border" />}
            // endMessage={
            //   <p className='text-success' style={{ textAlign: 'center' }}>
            //     {t(onlineExamString.listFinish)}
            //   </p>
            // }
            // below props only if you need pull down functionality
            refreshFunction={() => {
              checkUnfinishedExams()
              dispatch(resetPlanOffset())
              getExamList();
            }}
            pullDownToRefresh
            pullDownToRefreshThreshold={100}
            pullDownToRefreshContent={
              <p style={{ textAlign: 'center' }}>دریافت مجدد لیست</p>
            }
            releaseToRefreshContent={
              <p style={{ textAlign: 'center' }}>دریافت مجدد لیست</p>
            }
          >
            {onlineExamData.map((exam, id) => (
              <PlanCard {...exam} key={id} />
            ))}

          </InfiniteScroll>
          {onlineExamData.length === 0 &&
            <h3 className="text-center mt-5 app-text-gray">آزمون جاری برای شما وجود ندارد</h3>
          }
        </>

      ) : (
        //Error
        <Alert show={errorFetchingExams} variant="danger">
          <Alert.Heading>{t(commonStrigns.error)}</Alert.Heading>
          <p>
            {errorFetchingExams}
          </p>
          <hr />
          <div >
            <Button onClick={() => getExamList()} variant="outline-danger">
              {t(commonStrigns.retry)}
            </Button>
          </div>
        </Alert>
      )
      }
    </Box>
  );
};

const HintComponent = ({ title }) => {
  return (
    <div>
      <TiTick className="text-success" />
      <span>{title}</span>
    </div>

  )
}

export default withTranslation(stringFiles.common)(Plan);
